module.exports = __webpack_public_path__ + "img/i-support-ticket-admin.621ab312.svg";